import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {saveAs} from 'file-saver';
import {HttpClient} from "@angular/common/http";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {FormBuilder, NgForm} from '@angular/forms';
import {environment} from "../../../../environments/environment";
import {OktaAuthService} from "@okta/okta-angular";
import * as moment from "moment";
import {UtilService} from "../../../services/util.service";

@Component({
  selector: 'app-generate-contract-dialog',
  templateUrl: './generate-contract-dialog.component.html',
  styleUrls: ['./generate-contract-dialog.component.scss']
})
export class GenerateContractDialogComponent implements OnInit {
  @ViewChild(NgForm) form;
  market;
  contractType;
  priceTerm
  taxExempt = 'No'
  brokerFee = 0;
  price;
  customerName;
  dba;
  federalTaxId;
  broker;
  contactName;
  contactTitle;
  contactPhone;
  phoneExt;
  contactEmail;
  street;
  city;
  state;
  zipCode;
  utility;
  facility = [];
  error;
  termPriceList = [];
  errorInputs = {};
  term;
  startDate;
  utilityContractsFiles = {
    "AEP_TX_TCC": "TX-AEP-Texas-Central-SCOM_EFL.docx"
    , "AEP_TX_TNC": "TX-AEP-Texas-North-SCOM_EFL.docx"
    , "Centerpoint": "TX-Centerpoint-SCOM_EFL.docx"
    , "Oncor": "TX-Oncor-SCOM_EFL.docx"
    , "TNMP": "TX-TNMP-SCOM_EFL.docx"
  }

  priceType = {'ERCOT': '¢/kWh', 'PJM': '$/kWh'};
  priceSign = {'ERCOT': '¢', 'PJM': '$'};
  endDate;

  downloadProgress = 0;

  constructor(public utilService: UtilService,private http: HttpClient, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data, public oktaAuth: OktaAuthService,) {

  }

  ngOnInit() {

    this.oktaAuth.getUser().then(data => {
      this.broker = (data.company ? data.company : '');
    });
    this.startDate = this.data.startDate;
    this.contractType = this.data.contractType;
    this.utility = this.data.utility;
    this.market = this.data.market;
    this.termPriceList = this.getPriceList(this.data.priceDetail)
    if (this.market === 'PJM' && 'accountList' in this.data) {
      for (let account of this.data.accountList) {
        this.addFacility(account);
      }
    }
    if (this.market == 'ERCOT') {
      this.addFacility('');
    }


  }


  validateForm() {
    this.errorInputs = {};
    this.error = '';
    if (!this.form.valid) {
      for (const name in this.form.controls) {

        if (this.form.controls[name].invalid) {
          this.errorInputs[name] = true;
        }

      }
      this.error = 'Please enter all all required fields';

    }
    return this.form.valid
  }

  downloadFile(fileName) {
    const url: string = environment.apiUrl + 'download-contract/' + fileName;
    this.downloadProgress++;
    this.http.get(url, {responseType: 'blob'}).subscribe((response: Blob) => {
      saveAs(response, fileName);
      this.downloadProgress--;
    });
  }

  public generateContract() {

    if (!this.validateForm()) {

      return
    }
    const facilityList = JSON.parse(JSON.stringify(this.facility));
    facilityList.push({});
    facilityList.push({});
    facilityList.push({});
    const url: string = environment.apiUrl + 'generate-contract';
    const payLoad = {};
    payLoad['taxExempt'] = this.taxExempt;
    payLoad['term'] = this.term;
    payLoad['contractType'] = this.contractType
    payLoad['customerName'] = this.customerName
    payLoad['dba'] = (this.dba ? this.dba : '')
    payLoad['federalTaxId'] = (this.federalTaxId ? this.federalTaxId : '')
    payLoad['contactName'] = (this.contactName ? this.contactName : '')
    payLoad['contactTitle'] = (this.contactTitle ? this.contactTitle : '')
    payLoad['contactPhone'] = (this.contactPhone ? this.contactPhone + (this.phoneExt ? ' ext ' + this.phoneExt : '') : '')
    payLoad['contactEmail'] = (this.contactEmail ? this.contactEmail : '')
    payLoad['street'] = (this.street ? this.street : '')
    payLoad['city'] = (this.city ? this.city : '')
    payLoad['state'] = (this.state ? this.state : '')
    payLoad['zipCode'] = (this.state ? this.zipCode : '')
    payLoad['price'] = this.price
    payLoad['broker'] = this.broker
    payLoad['facilityList'] = facilityList
    payLoad['utility'] = this.utility
    payLoad['startDate'] = this.startDate
    payLoad['endDate'] = this.endDate

    this.downloadProgress++;
    this.http.post(url, payLoad, {responseType: 'blob'}).subscribe((response: Blob) => {
      saveAs(response, this.contractType + '_Standard');
      this.downloadProgress--;
    });

  }

  addFacility(account) {
    this.facility.push({
      accountNumber: account,
      utility: this.utility,
      serviceAddress: '',
      startDate: this.startDate,
      endDate: '',
      plc: '',
      nspl: '',
      taxExempt:'No'
    });
  }

  removeFacility(index) {
    this.facility.splice(index, 1);
  }

  changePrice() {
    this.price = (parseFloat(this.priceTerm.price) + this.brokerFee).toFixed(4);
    this.term = this.priceTerm.term;
    this.endDate = moment(this.startDate, 'YYYY-MM-DD').add(this.term, 'months').format('YYYY-MM-DD')
    this.updateFacilityEndDate();
  }

  updateFacilityEndDate() {
    for (let fac of this.facility) {
      fac.endDate = this.endDate;
    }
  }

  getPriceList(termsPrice) {
    const priceList = [];
    if (termsPrice.month6 && !isNaN(termsPrice['month6'])) {
      priceList.push({price: termsPrice['month6'], term: '6'})
    }
    if (termsPrice.month12 && !isNaN(termsPrice['month12'])) {
      priceList.push({price: termsPrice['month12'], term: '12'})
    }
    if (termsPrice.month18 && !isNaN(termsPrice['month18'])) {
      priceList.push({price: termsPrice['month18'], term: '18'})
    }
    if (termsPrice.month24 && !isNaN(termsPrice['month24'])) {
      priceList.push({price: termsPrice['month24'], term: '24'})
    }
    if (termsPrice.month36 && !isNaN(termsPrice['month36'])) {
      priceList.push({price: termsPrice['month36'], term: '36'})
    }
    if (termsPrice.month48 && !isNaN(termsPrice['month48'])) {
      priceList.push({price: termsPrice['month48'], term: '48'})
    }
    if (termsPrice.month60 && !isNaN(termsPrice['month60'])) {
      priceList.push({price: termsPrice['month60'], term: '60'})
    }
    if (termsPrice.sweetPrice && !isNaN(termsPrice['sweetPrice'])) {
      priceList.push({price: termsPrice['sweetPrice'], term: termsPrice['sweetTerm']})
    }
    return priceList;

  }


  phoneChanged(value){
      this.contactPhone = this.utilService.formatPhoneNumber(this.contactPhone)
  }

}
